export enum AuthProvider {
  Password = 'password',
  Facebook = 'facebook',
  Google = 'google'
}
